import { cn } from "@/lib/utils"

export type TinyTextProps = {
  error?: boolean
  text?: string
  className?: string
}

export function TinyText({ error, text, className }: TinyTextProps) {
  return (
    <p
      className={cn(
        "text-tiny text-label-text mt-1 font-medium leading-2.5",
        error && "text-error",
        className
      )}
    >
      {text}
    </p>
  )
}
